module.exports = __webpack_public_path__ + "static/img/23_fengsu.2aff8347.png";